import { render, staticRenderFns } from "./Companion.vue?vue&type=template&id=48dfd544&scoped=true&"
import script from "./Companion.vue?vue&type=script&lang=js&"
export * from "./Companion.vue?vue&type=script&lang=js&"
import style0 from "./Companion.vue?vue&type=style&index=0&id=48dfd544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dfd544",
  null
  
)

export default component.exports